import { Injectable } from 'ng-metadata/core';
import { AbstractRequest } from '../abstractRequest';
import { FormBuilderEnums,PERSONAL_DELIVERY } from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class AlmaItemRequest extends AbstractRequest {


    constructor(
        private mappingTablesCache: MappingTablesCache,
        private configurationUtil:ConfigurationUtil) {
        super();
        this.formFields = [
            {
                key: 'hold-or-booking',
                name: 'requestType',
                label: 'almaRequest.requestType',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                path: 'requestType',
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                singleValueUiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator: {
                    func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        defaultValue: FormBuilderEnums.FIRST,
                        singleValueBehaviour: FormBuilderEnums.UI_TYPE.HIDDEN
                    }
                },
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            }, {
                key: 'itemDescription',
                name: 'itemDescription',
                label: 'almaItemRequest.itemDescription',
                mandatory: false,
                valuePath: 'itemDescription',
                existingPath: 'itemDescription',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.LABEL

            }, {
                key: 'pickupInstitution',
                name: 'pickupInstitution',
                path: 'groups-list-map/pickupInstitution',
                label: 'almaRequest.pickupInstitution',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpInstitution',
                filterSearchAriaLabel: 'nui.aria.lookUpInstitution',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator: {
                    func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        byCategory: 'category',
                        filters: ['pickupLocation', 'termsOfUse',
                            'materialType', 'requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            }, {
                key: 'pickupLocation',
                name: 'pickupLocation',
                path: 'groups-list-map/pickupLocation',
                label: 'almaRequest.pickupLocation',
                filterSearchPlaceHolderLabel: 'nui.request.lookUpLocation',
                filterSearchAriaLabel: 'nui.aria.lookUpLocation',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
                populator: {
                    func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        byCategory: 'category',
                        filters: ['pickupInstitution', 'termsOfUse',
                            'materialType', 'requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: { key: 'requestType', value: ['booking', 'hold'] }
            },
            {
                key: 'addressLine1',
                name: 'addressLine1',
                label: 'almaRequest.addressLine1',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine2',
                name: 'addressLine2',
                label: 'almaRequest.addressLine2',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine3',
                name: 'addressLine3',
                label: 'almaRequest.addressLine3',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'addressLine4',
                name: 'addressLine4',
                label: 'almaRequest.addressLine4',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'city',
                name: 'city',
                label: 'almaRequest.city',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'stateProvince',
                name: 'stateProvince',
                label: 'almaRequest.stateProvince',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'postalCode',
                name: 'postalCode',
                label: 'almaRequest.postalCode',
                existingPath: 'dummyPath',
                mandatoryGroup:PERSONAL_DELIVERY,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {method: this.personalDeliveryDependency.bind(this)}
            },
            {
                key: 'termsOfUse',
                name: 'termsOfUse',
                path: 'groups-list-map/termsOfUse',
                label: 'almaRequest.termsOfUse',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator: {
                    func: this.itemsArrayPopulator.bind(this),
                    params: {
                      	key: 'key',
                        value: 'value',
                        filters: ['pickupInstitution', 'pickupLocation',
                            'materialType', 'requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                dependOn: { key: 'requestType', value: 'hold' }
            }, {
                key: 'materialType',
                name: 'materialType',
                path: 'groups-list-map/materialType',
                label: 'almaRequest.materialType',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator: {
                    func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        filters: ['pickupInstitution', 'pickupLocation',
                            'termsOfUse', 'requestType']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
            },
            {
                key: 'notNeedAfter',
                name: 'lastInterestDate',
                label: 'almaRequest.notNeedAfter',
                existingPath: 'dummyPath',
                valuePath: 'pickupDate',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                minDate: 'now',
                dependOn: { key: 'requestType', value: 'hold' },
                populator: {
                    params: {
                        allow: FormBuilderEnums.FUTURE_DATES
                    }
                }

            },

            {
                key: 'checkAvailiability',
                name: 'checkAvailiability',
                label: 'almaRequest.checkAvailiability',
                existingPath: 'checkAvailiability',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.LINK,
                dependOn: { key: 'requestType', value: 'booking' },
                populator: {
                    func: this.checkAvailabilityLinkPopulator.bind(this),
                    allowEmptyOptions: true
                }
            },
            {
                key: 'bookingResolution',
                name: 'bookingResolution',
                label: 'almaRequest.bookingResolution',
                existingPath: 'bookingResolution',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                dependOn: { key: 'requestType', value: 'booking' }
            },
            {
                key: 'startDate',
                name: 'startDate',
                label: 'almaRequest.startDate',
                existingPath: 'dummyPath',
                mandatory: true,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: { method: this.getUITypeByBookingResolution.bind(this) },
                minDate: 'now',
                dependOn: { key: 'requestType', value: 'booking' }
            },
            {
                key: 'endDate',
                name: 'endDate',
                label: 'almaRequest.endDate',
                existingPath: 'dummyPath',
                mandatory: true,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: { method: this.getUITypeByBookingResolution.bind(this) },
                minDate: 'now',
                dependOn: { key: 'requestType', value: 'booking' }
            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaRequest.comment',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'itemId',
                name: 'itemId',
                label: 'almaRequest.itemId',
                mandatory: true,
                valuePath: 'itemId',
                existingPath: 'itemId',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },
            {
                key: 'calculateQueueButton',
                name: 'calculateQueueButton',
                label: 'request.calcPlaceInQueue',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.BUTTON_AND_TEXT,
                options: {
                    ariaLabel: 'nui.aria.request.calcPlaceInQueue',
                    textLabel: 'request.placeInQueue',
                    numInQueue: undefined
                },
                dependOn: { key: 'requestType', value: 'hold' }
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaRequest.genericCheckBox',
                        value:'N'
                    }
                ]
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaItemRequest.ts